import React from "react";
import './WallOfFameContent.css';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import WallOfFameData from '../data/HomeWallOfFame.json'
import FameWall from "./FameWall";
import FameWallJapanese from "./FameWallJapanese";
// import InactiveBG from "../Images/inactive-bg-tab.png";
// import ActiveBG from "../Images/active-bg-tab.png"
import { styled } from '@mui/material/styles';
import FloatIcon from "./FloatIcons/FloatIcons";

const StyledTabs = styled((props) => (
  <Tabs
    {...props}
    TabIndicatorProps={{ children: <span className="MuiTabs-indicatorSpan" /> }}
  />
))({
  '& .MuiTabs-indicator': {
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: 'transparent',
  },
  '& .MuiTabs-indicatorSpan': {
    maxWidth: 40,
    width: '100%',
    backgroundColor: '#635ee7',
  },
});

const StyledTab = styled((props) => <Tab disableRipple {...props} />)(
  ({ theme }) => ({
    textTransform: 'none',
    // fontWeight: theme.typography.fontWeightRegular,
    // fontSize: theme.typography.pxToRem(15),
    // marginRight: theme.spacing(1),
    color: '#8A8A8A',
    backgroundImage: "url(../../images/WallOfFame/inactive-bg.png)",
    backgroundRepeat: "no-repeat",
    backgroundSize: "contain",
    width: "9em",
    // height: "3em",
    '&.Mui-selected': {
      color: '#000',
      backgroundImage: "url(../../images/WallOfFame/active-bg.png)"
    }

  }),
);

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

function WallOfFameContent() {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  return (
    <>
      <div className="floatIconsContainer">
        <FloatIcon />
      </div>
      <div className="fame-banner-container">
        <img src="/images/WallOfFame/Banner.png" alt="wall-of0fame-banner" className="banner-walloffame" />
        <h1>Wall of Fame</h1>
      </div>
      <div className="wall-container">
        <div className="wall-wrap">
          <img src="/images/WallOfFame/trophy.png" alt="trophy-icon" className="trophy-icon" />
          <div>
            <h1>L&TT Foreign Language Wall of Fame</h1>
            <div class="border-gradient horizontal-underline only-top"></div>
          </div>
          <img src="/images/WallOfFame/trophy.png" alt="trophy-icon" className="trophy-icon" />
        </div>
        <p className="wall-intro">We are thrilled to announce and celebrate the outstanding achievements of our top scorers in the language exams! These dedicated individuals have demonstrated exceptional proficiency and mastery in their chosen languages, setting a remarkable standard for language learning excellence.
          <br /> <br />
          <span>Join us in congratulating our top scorers !</span></p>
      </div>

      <div className="tabs-container">
        <Box sx={{ width: '100%' }}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <StyledTabs value={value} onChange={handleChange} aria-label="basic tabs example">
              <StyledTab label="French" {...a11yProps(0)}><span>&nbsp;</span></StyledTab>
              <StyledTab label="Spanish" {...a11yProps(1)}><span>&nbsp;</span></StyledTab>
              <StyledTab label="Italian" {...a11yProps(2)}><span>&nbsp;</span></StyledTab>
              <StyledTab label="German" {...a11yProps(3)}><span>&nbsp;</span></StyledTab>
              <StyledTab label="Japanese" {...a11yProps(4)}><span>&nbsp;</span></StyledTab>
            </StyledTabs>
            {/* rounded corner tab background for polygon  starts */}
            {/* <svg sx={{ position: 'absolute', visibility: 'hidden' }} width="0" height="0" xmlns="http://www.w3.org/2000/svg" version="1.1">
              <defs>
                <filter id="rounded"><feGaussianBlur in="SourceGraphic" stdDeviation="4" result="blur" />
                  <feColorMatrix in="blur" mode="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 19 -9" result="rounded" />
                  <feComposite in="SourceGraphic" in2="rounded" operator="atop" />
                </filter>
              </defs>
            </svg> */}
            {/* rounded corner tab background for polygon ends */}
          </Box>
          <CustomTabPanel value={value} index={0} >
            <div className="cards-container">
              <div className="cards-wrap">
                {WallOfFameData.filter(item => item.language === "French").map((item) => {
                  return (
                    < div className="cards-box" >
                      <img src={item.backgroundImgPath} alt="background-img" className="bg-img" />
                      <img src={item.displayPicture} alt="display-picture" className="display-picture" />
                      <div className="lang-name">{item.language + " " + item.languageLevel}</div>
                      <div className="card-name">{item.name}</div>
                    </div>
                  )
                }
                )}
              </div>
            </div>
          </CustomTabPanel>
          <CustomTabPanel value={value} index={1}>
            <div className="cards-container">
              <div className="cards-wrap">
                {WallOfFameData.filter(item => item.language === "Spanish").map((item) => {
                  return (
                    < div className="cards-box" >
                      <img src={item.backgroundImgPath} alt="background-img" className="bg-img" />
                      <img src={item.displayPicture} alt="display-picture" className="display-picture" />
                      <div className="lang-name">{item.language + " " + item.languageLevel}</div>
                      <div className="card-name">{item.name}</div>
                    </div>
                  )
                }
                )}
              </div>
            </div>
          </CustomTabPanel>
          <CustomTabPanel value={value} index={2}>
            <div className="cards-container">
              <div className="cards-wrap">
                {WallOfFameData.filter(item => item.language === "Italian").map((item) => {
                  return (
                    < div className="cards-box" >
                      <img src={item.backgroundImgPath} alt="background-img" className="bg-img" />
                      <img src={item.displayPicture} alt="display-picture" className="display-picture" />
                      <div className="lang-name">{item.language + " " + item.languageLevel}</div>
                      <div className="card-name">{item.name}</div>
                    </div>
                  )
                }
                )}
              </div>
            </div>
          </CustomTabPanel>
          <CustomTabPanel value={value} index={3}>
            <div className="cards-container">
              <div className="cards-wrap">
                {WallOfFameData.filter(item => item.language === "German").map((item) => {
                  return (
                    < div className="cards-box" >
                      <img src={item.backgroundImgPath} alt="background-img" className="bg-img" />
                      <img src={item.displayPicture} alt="display-picture" className="display-picture" />
                      <div className="lang-name">{item.language + " " + item.languageLevel}</div>
                      <div className="card-name">{item.name}</div>
                    </div>
                  )
                }
                )}
              </div>
            </div>
          </CustomTabPanel>
          <CustomTabPanel value={value} index={4}>
            <div className="cards-container">
              <div className="cards-wrap">
                {WallOfFameData.filter(item => item.language === "Japanese").map((item) => {
                  return (
                    < div className="cards-box" >
                      <img src={item.backgroundImgPath} alt="background-img" className="bg-img" />
                      <img src={item.displayPicture} alt="display-picture" className="display-picture" />
                      <div className="lang-name">{item.language + " " + item.languageLevel}</div>
                      <div className="card-name">{item.name}</div>
                    </div>
                  )
                }
                )}
              </div>
            </div>
          </CustomTabPanel>
        </Box>
      </div >

      {value == 4 ? <FameWallJapanese /> : <FameWall />}

    </>
  );
}

export default WallOfFameContent;
